"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.logAnalytics = exports.default = void 0;
const prodAppHosts = ['id.asics.com', 'one.asics.com', 'partners.one.asics.com'];
const TEALIUM_ASYNC_SCRIPT_ID = 'tealium_async';
const isPWA = () => window.matchMedia('(display-mode: standalone)').matches ? 'pwa' : 'web';
const [asicsAnalyticsUrl, tealiumScriptUrl] = prodAppHosts.includes(window.location.host) ? ['https://events-logger.data-engineering.prod.asics.digital/events/oneasics-analytics-events', 'https://tags.tiqcdn.com/utag/asics/oneasics/prod/utag.js'] : ['https://events-logger-stg.data-engineering.prod.asics.digital/events/oneasics-analytics-events', 'https://tags.tiqcdn.com/utag/asics/oneasics/dev/utag.js'];
const analyticsBase = () => {
  var _window$previousView, _window$utag_data;
  return {
    is_pwa: isPWA(),
    prev_view: (_window$previousView = window.previousView) !== null && _window$previousView !== void 0 ? _window$previousView : '',
    screen_width: window.innerWidth,
    tealium_id: (_window$utag_data = window.utag_data) === null || _window$utag_data === void 0 ? void 0 : _window$utag_data.tealium_visitor_id,
    timestamp: Date.now(),
    user_agent: navigator.userAgent
  };
};
const getTealiumEventLabel = _ref => {
  let {
    error,
    event_name,
    event_type
  } = _ref;
  if (event_type === 'success') {
    return 'success';
  }
  if (event_type === 'error') {
    return error;
  }
  return event_name;
};
const getTealiumBrand = style => {
  var _styleToBrandMapping$;
  const styleToBrandMapping = {
    runkeeper: 'ID.RK',
    haglofs: 'ID.HAGLOFS',
    onitsuka_tiger: 'ID.OT'
  };
  return (_styleToBrandMapping$ = styleToBrandMapping[style]) !== null && _styleToBrandMapping$ !== void 0 ? _styleToBrandMapping$ : 'ID.ASICS';
};
const fireTealiumEvent = _ref2 => {
  let {
    app_id,
    client_id,
    dyData,
    environment,
    error,
    event_name,
    event_type,
    gaEventCategory,
    gaEventLabel,
    gaEventAction,
    gaEventNonInteraction,
    locale,
    page,
    region,
    style
  } = _ref2;
  if (event_type === 'pageview') {
    window.utag.view({
      app_client_id: client_id,
      app_id,
      brand: getTealiumBrand(style),
      country: locale.slice(-2).toUpperCase(),
      forceSSL: true,
      ga_virtual_pathname: `${locale.slice(-2).toLowerCase()}/${locale.toLowerCase()}/oneasics/${page}`,
      hit_source: 'tealium',
      is_ecommerce: 'yes',
      page_type: page,
      // Strip "!new" off of the end of the region if it's there.
      region: region === null || region === void 0 ? void 0 : region.split('!new')[0],
      site_environment: environment
    });
  } else {
    window.utag.link({
      gaEventAction: gaEventAction !== null && gaEventAction !== void 0 ? gaEventAction : event_type,
      gaEventCategory: gaEventCategory !== null && gaEventCategory !== void 0 ? gaEventCategory : page,
      gaEventLabel: gaEventLabel !== null && gaEventLabel !== void 0 ? gaEventLabel : getTealiumEventLabel({
        error,
        event_name,
        event_type
      }),
      gaEventNonInteraction: gaEventNonInteraction !== null && gaEventNonInteraction !== void 0 ? gaEventNonInteraction : event_type === 'success' || event_type === 'error',
      gaEventValue: undefined,
      dyData
    });
  }
};
const logTealiumAnalytics = body => {
  const {
    app_id,
    client_id,
    environment,
    region,
    style
  } = body;
  if (document.getElementById(TEALIUM_ASYNC_SCRIPT_ID) && window.utag) {
    fireTealiumEvent(body);
  } else {
    // Set utag_data values
    window.utag_data = window.utag_data || {
      app_id,
      app_client_id: client_id,
      brand: getTealiumBrand(style),
      region,
      site_environment: environment
    };

    // Disables automatic page tracking, must be set before loading Tealium script
    window.utag_cfg_ovrd = window.utag_cfg_ovrd || {};
    window.utag_cfg_ovrd.noview = true;
    const tealiumAsyncScript = document.createElement('script');
    tealiumAsyncScript.setAttribute('type', 'text/javascript');
    tealiumAsyncScript.setAttribute('async', 'true');
    tealiumAsyncScript.setAttribute('id', TEALIUM_ASYNC_SCRIPT_ID);
    tealiumAsyncScript.setAttribute('src', tealiumScriptUrl);
    document.head.appendChild(tealiumAsyncScript);
    tealiumAsyncScript.onload = () => fireTealiumEvent(body);
  }
};

/**
 * Send a request to our ASICS events endpoint for event data accumulation in Snowflake.
 * @param {Object} data
 * @param {boolean} logTealium Also log analytics data to Tealium
 */
// TODO: Consolidate analytics functions in oneasics-instore and oneasics-membership here
const logAnalytics = async function () {
  let data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  let logTealium = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  const body = {
    ...analyticsBase(),
    ...data
  };
  window.previousView = window.previousView !== data.page ? data.page : window.previousView;
  const beaconData = JSON.stringify(body);
  // We're sending JSON, but we set the type to 'text/plain' to make this a simple request, avoiding CORS errors.
  const headers = {
    type: 'text/plain'
  };
  if (navigator.sendBeacon) {
    navigator.sendBeacon(asicsAnalyticsUrl, new Blob([beaconData], headers));
  } else {
    fetch(asicsAnalyticsUrl, {
      method: 'POST',
      body: beaconData
    }).then(response => response.json()).catch(error => error);
  }
  if (logTealium) {
    logTealiumAnalytics(body);
  }
};
exports.logAnalytics = logAnalytics;
const AnalyticsApi = {
  logAnalytics
};
var _default = exports.default = AnalyticsApi;